import { formatDateFromDB } from '../../../../../utils/FormatDate';

const PHASE_DEFINITIONS = [
  {
    key: 'pripremaDokumentacije',
    ikonica: 'fas fa-file-alt',
  },
  {
    key: 'konstruisanje',
    ikonica: 'fas fa-drafting-compass',
  },
  {
    key: 'porucivanjeOpreme',
    ikonica: 'fas fa-shopping-cart',
  },
  {
    key: 'tehnoloskaPriprema',
    ikonica: 'fas fa-cogs',
  },
  {
    key: 'izradaDokumentacije',
    ikonica: 'fas fa-folder-open',
  },
  {
    key: 'programiranje',
    ikonica: 'fas fa-code',
  },
  {
    key: 'izradaMasinskihDelova',
    ikonica: 'fas fa-cog',
  },
  {
    key: 'masinskaMontaza',
    ikonica: 'fas fa-tools',
  },
  {
    key: 'elektroMontaza',
    ikonica: 'fas fa-bolt',
  },
  {
    key: 'testiranje',
    ikonica: 'fas fa-shield-alt',
  },
  {
    key: 'isporukaIPustanjeURad',
    ikonica: 'fas fa-truck',
  },
];

export { PHASE_DEFINITIONS };

const PHASE_COLORS = [
  '#7c3aed',
  '#2563eb',
  '#0ea5e9',
  '#0891b2',
  '#22c55e',
  '#16a34a',
  '#eab308',
  '#f97316',
  '#ef4444',
  '#8b5cf6',
  '#6366f1',
];

const GRAY_COLOR = '#d1d5db';

const toNumber = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

const formatProgres = (value) => {
  const num = toNumber(value);
  return Number.isInteger(num) ? num : parseFloat(num.toFixed(2));
};

const getBarWidth = (value) => Math.min(100, Math.max(0, toNumber(value)));

const getField = (data, key) => {
  if (!data) return undefined;

  if (data[key] !== undefined && data[key] !== null) {
    return data[key];
  }

  const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
  if (data[pascalKey] !== undefined && data[pascalKey] !== null) {
    return data[pascalKey];
  }

  return undefined;
};

export const getProgresField = getField;

export const normalizeProgresResponse = (response) => {
  if (!response || response?.isAxiosError) return null;
  if (Array.isArray(response)) return response[0] ?? null;
  return response;
};

export const mapProgresData = (response) => {
  const data = normalizeProgresResponse(response);
  if (!data) return null;

  const phases = PHASE_DEFINITIONS.map((def, index) => {
    const procenat = formatProgres(getField(data, `${def.key}Progres`));
    const prikazValue = getField(data, `${def.key}Prikaz`);
    const prikaz = prikazValue !== false && prikazValue !== 0;
    const boja = prikaz
      ? PHASE_COLORS[index % PHASE_COLORS.length]
      : GRAY_COLOR;
    const idFieldKey = `id${def.key.charAt(0).toUpperCase()}${def.key.slice(
      1,
    )}`;

    const imaFajlValue = getField(data, `${def.key}ImaFajl`);
    const imaFajl = imaFajlValue === true || imaFajlValue === 1;

    return {
      id: index + 1,
      key: def.key,
      ikonica: def.ikonica,
      procenat,
      procenatBar: getBarWidth(procenat),
      prikaz,
      boja,
      idPPF: getField(data, idFieldKey) ?? null,
      metadata: getField(data, `${def.key}Metadata`) || null,
      imaFajl,
    };
  });

  const ukupanProgres = formatProgres(getField(data, 'ukupanProgres'));
  const predvidjeniDatum = getField(data, 'predvidjeniDatumIzrada');

  return {
    project: {
      procenat: ukupanProgres,
      procenatBar: getBarWidth(ukupanProgres),
      procenjenoZavrsetak: predvidjeniDatum
        ? formatDateFromDB(predvidjeniDatum)
        : '—',
      slika: getField(data, 'slikaUrl') || null,
      naziv: getField(data, 'vrednost') || '',
    },
    phases,
  };
};
